import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const userApi = {
	getCurrentUser: () => {
		return axios
			.get(`${apiUrl}/current-user`)
			.then((response) =>
				response ? (response.data as CurrentUserDTO) : ({} as CurrentUserDTO)
			);
	},
	getUser: (userId: string) => {
		return axios
			.get(`${apiUrl}/users/${userId}`)
			.then((response) => response.data as UserDetailsDTO);
	},
	getUsers: (tenantId?: string) => {
		let url = `${apiUrl}/users`;
		if (tenantId) {
			url += `/tenant/${tenantId}`;
		}
		return axios.get(url).then((response) => response.data as UserDetailsDTO[]);
	},
	saveUser: (item: any) => {
		return axios
			.post(`${apiUrl}/users`, item)
			.then((response) => response.data as UserDetailsDTO);
	},
	getAllUsers: () => {
		let url = `${apiUrl}/users/allusers`;
		return axios.get(url).then((response) => response.data as UserSummaryDTO[]);
	},
};

export default userApi;
